/** Textes « connexion » — le français fait foi. */
export const connexion = {
  impossible: 'Connexion impossible',
  sousTitre: "Location de véhicules — Gestion d'agence",
  accroche: 'Vos règles ne sont plus seulement écrites au dos du contrat.',
  accrocheSuite: 'Elles sont appliquées.',
  titre: 'Connexion',
  identifiezVous: 'Identifiez-vous pour accéder à votre poste.',
  email: 'Adresse e-mail',
  motDePasse: 'Mot de passe',
  envoi: 'Connexion…',
  seConnecter: 'Se connecter',
  demonstration: 'Démonstration : les comptes créés par « npm run mise-en-service »',
  serveur: (adresse: string) => `Serveur : ${adresse}`,
  memeOrigine: 'même origine',
  adresseServeur: 'Adresse du serveur',
  adresseServeurAide: "Collez l'adresse du serveur, puis appuyez sur Entrée.",
};
